import { apiService, TAG } from "./api/ApiService";
import { editoService } from "./api/EditoService";

import { leMagService } from "./api/LeMagService";
import metricsService from "./metrics/MetricsService";
import analyticsService from "./service/AnalyticsService";
import { Token } from "./model/Token";
export * from "./api";
export * from "./crypto";
export * from "./metrics";
export * from "./model";
export * from "./utils";
export * from "./ws";

export { cryptoProvider };
export { apiService };
export { leMagService };
export { metricsService };
export { analyticsService };
export { editoService };

import cryptoProvider from "./crypto";
import { logger, LoggingConfig, logW } from "@blacknut/logging/dist";
import { UserAgent } from "./model/UserAgent";

export type SDKConfig = {
  userAgent: UserAgent;
  endpoint?: string;
  userToken?: Token;
  familyToken?: Token;
  logging?: LoggingConfig;
  locale?: string;
};

const CONFIGURED = [false];

export const cleanup = () => {
  CONFIGURED[0] = false;
  apiService.cleanup();
};

export const configure = ({
  userAgent,
  endpoint,
  userToken,
  familyToken,
  logging,
  locale,
}: SDKConfig) => {
  // if family token is not provided this can induce some unwanted side effects
  // To properly clean cleanup must be called beforehand
  if (CONFIGURED[0] || apiService.userToken || apiService.familyToken) {
    logW(TAG, "Already configured. Must call cleanup beforehand");
    return;
  }
  CONFIGURED[0] = true;
  apiService.cleanup();
  if (endpoint) {
    apiService.endpoint = endpoint;

    if (endpoint.match("api.blacknut.com")) {
      metricsService.endpoint = "https://metrics2.blacknut.com";
      analyticsService.endpoint = "https://a.blacknut.com/event";
    } else if (endpoint.match("staging-api")) {
      metricsService.endpoint = "https://staging-metrics2.blacknut.net";
      analyticsService.endpoint = "https://a.blacknut.com/staging";
    } else if (endpoint.match("dev-api")) {
      metricsService.endpoint = "https://dev-metrics2.blacknut.net";
      analyticsService.endpoint = "https://a.blacknut.com/dev";
    }
  }
  if (userToken) {
    apiService.userToken = userToken;
    metricsService.userToken = userToken;
  }

  if (familyToken) {
    apiService.familyToken = familyToken;
  }

  apiService.userAgent = userAgent;
  metricsService.userAgent = { ...userAgent, apiVersion: "5.0.2" };
  analyticsService.userAgent = userAgent;

  if (logging) {
    logger.configure(logging);
  }

  apiService.locale = locale;
};
